var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, Tooltip, useTheme, Typography } from '@mui/material';
import React from 'react';
import { baseColors } from '../../Themes/colors';
var CustomButton = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, startIcon = _a.startIcon, endIcon = _a.endIcon, bgColor = _a.bgColor, borderColor = _a.borderColor, textColor = _a.textColor, onClick = _a.onClick, sx = _a.sx, _c = _a.SMButton, SMButton = _c === void 0 ? false : _c, _d = _a.MDButton, MDButton = _d === void 0 ? false : _d, _e = _a.XSButton, XSButton = _e === void 0 ? false : _e, disabledTooltip = _a.disabledTooltip, disabled = _a.disabled, _f = _a.fullWidth, fullWidth = _f === void 0 ? true : _f, _g = _a.iconSize, iconSize = _g === void 0 ? 16 : _g, props = __rest(_a, ["children", "variant", "startIcon", "endIcon", "bgColor", "borderColor", "textColor", "onClick", "sx", "SMButton", "MDButton", "XSButton", "disabledTooltip", "disabled", "fullWidth", "iconSize"]);
    var theme = useTheme();
    var variantStyles = {
        contained: {
            backgroundColor: bgColor || baseColors.successPreset[30],
            border: "1px solid ".concat(bgColor || baseColors.successPreset[30]),
            color: textColor || baseColors.fullWhite,
            '&:hover': {
                backgroundColor: bgColor || baseColors.successPreset[10],
                border: "1px solid ".concat(bgColor || baseColors.bluePreset[20]),
            },
            '&.Mui-disabled': {
                borderColor: baseColors.greyPreset[20],
                backgroundColor: baseColors.greyPreset[20],
                color: theme.palette.text.disabled,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
                '& .MuiButton-startIcon svg, & .MuiButton-endIcon svg': {
                    color: theme.palette.text.disabled,
                    '& path': {
                        fill: theme.palette.text.disabled,
                    },
                },
            },
            '& svg': {
                color: textColor || baseColors.fullWhite,
                '& path': {
                    fill: textColor || baseColors.fullWhite,
                },
            },
        },
        outlined: {
            border: "1px solid ".concat(borderColor || baseColors.successPreset[30]),
            color: textColor || baseColors.successPreset[30],
            backgroundColor: baseColors.successPreset[20],
            '&:hover': {
                backgroundColor: bgColor || theme.palette.action.hover,
                border: "1px solid ".concat(borderColor || baseColors.successPreset[30]),
            },
            '&.Mui-disabled': {
                borderColor: baseColors.greyPreset[20],
                backgroundColor: baseColors.greyPreset[20],
                color: theme.palette.text.disabled,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
                '& .MuiButton-startIcon svg, & .MuiButton-endIcon svg': {
                    color: theme.palette.text.disabled,
                    '& path': {
                        fill: theme.palette.text.disabled,
                    },
                },
            },
            '& svg, & span': {
                color: textColor || baseColors.successPreset[30],
                '& path': {
                    fill: textColor || baseColors.successPreset[30],
                },
            },
        },
        text: {
            color: textColor || baseColors.successPreset[30],
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: bgColor || baseColors.greyPreset[40],
            },
            '&.Mui-disabled': {
                cursor: 'not-allowed',
                pointerEvents: 'auto',
                backgroundColor: 'transparent',
                color: theme.palette.text.disabled,
            },
        },
        secondary: {
            backgroundColor: bgColor || baseColors.greyPreset[60],
            color: textColor || baseColors.darkPreset[10],
            '&:hover': {
                backgroundColor: bgColor || baseColors.successPreset[20],
                color: textColor || baseColors.successPreset[30],
            },
            '&.Mui-disabled': {
                borderColor: baseColors.greyPreset[20],
                backgroundColor: baseColors.greyPreset[20],
                color: theme.palette.text.disabled,
                cursor: 'not-allowed',
                pointerEvents: 'auto',
                '& .MuiButton-startIcon svg, & .MuiButton-endIcon svg': {
                    color: theme.palette.text.disabled,
                    '& path': { fill: theme.palette.text.disabled },
                },
            },
            '& svg': {
                color: textColor || baseColors.darkPreset[10],
                '& path': {
                    fill: textColor || baseColors.darkPreset[10],
                },
            },
        },
    };
    var _h = variantStyles[variant] || {}, _j = _h["&:hover"], variantHover = _j === void 0 ? {} : _j, restVariantStyles = __rest(_h, ['&:hover']);
    var buttonSx = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, theme.typography.h6), { textTransform: 'none', borderRadius: 1, fontWeight: '700', p: '12.5px', minWidth: 'unset', boxShadow: 'none', height: 'fit-content' }), restVariantStyles), { '&:hover': __assign({ boxShadow: 'none' }, variantHover) }), sx), { '& .MuiTypography-root': {
            fontWeight: 700,
        }, '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            '& span': {
                fontSize: iconSize,
                fontWeight: 500,
            },
        } }), (XSButton && {
        py: '6.5px',
        lineHeight: 'normal',
        '& .MuiTypography-root': __assign({}, theme.typography.overline),
    })), (SMButton && {
        p: '6px 12px',
        lineHeight: 'normal',
        '& .MuiTypography-root': __assign({}, theme.typography.subtitle2),
    })), (MDButton && __assign(__assign({}, theme.typography.body2), { p: '8px 12px', lineHeight: 'normal', '& .MuiTypography-root': __assign({}, theme.typography.subtitle1) })));
    var button = (React.createElement(Button, __assign({ variant: variant === 'secondary' ? 'contained' : variant, startIcon: startIcon, endIcon: endIcon, onClick: onClick, sx: buttonSx, disabled: disabled, fullWidth: fullWidth }, props),
        React.createElement(Typography, null, children)));
    var showDisabledTooltip = Boolean(disabled && disabledTooltip);
    if (showDisabledTooltip) {
        return (React.createElement(Tooltip, { title: disabledTooltip, placement: "top", arrow: true },
            React.createElement("span", { style: { display: 'inline-flex', } }, button)));
    }
    return button;
};
export default CustomButton;
